<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="600"
    class-name="invoice-title-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">我的开票信息管理</span>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <span class="form-label required">抬头类型</span>
        <RadioGroup v-model="form.type">
          <Radio :label="0" :disabled="form.type === 1">个人</Radio>
          <Radio :label="1" :disabled="form.type === 0">企业</Radio>
        </RadioGroup>
      </div>

      <!-- 个人 -->
      <template v-if="form.type === 0">
        <div class="form-row">
          <span class="form-label required">发票抬头</span>
          <Input v-model="form.title" placeholder="请输入发票抬头" />
        </div>
        <div class="form-row">
          <span class="form-label">收票邮箱</span>
          <Input v-model="form.send_mail" placeholder="输入电子邮箱，后续开票成功发票文件将默认推送至该邮箱" />
        </div>
      </template>

      <!-- 企业 -->
      <template v-if="form.type === 1">
        <div class="form-row">
          <span class="form-label required">发票抬头</span>
          <Input v-model="form.title" placeholder="请输入企业名称" />
        </div>
        <div class="form-row">
          <span class="form-label required">税号</span>
          <Input v-model="form.tax_number" placeholder="请输入纳税人识别号" />
        </div>
        <div class="form-row">
          <span class="form-label" :class="{ required: form.tax_type === 1 }">开户银行</span>
          <Input v-model="form.bank_name" placeholder="专用发票请填写开户银行" />
        </div>
        <div class="form-row">
          <span class="form-label" :class="{ required: form.tax_type === 1 }">银行账号</span>
          <Input v-model="form.bank_account" placeholder="专用发票请填写银行账号" />
        </div>
        <div class="form-row">
          <span class="form-label" :class="{ required: form.tax_type === 1 }">企业地址</span>
          <Input v-model="form.company_address" placeholder="专用发票请填写注册地址" />
        </div>
        <div class="form-row">
          <span class="form-label" :class="{ required: form.tax_type === 1 }">企业电话</span>
          <Input v-model="form.phone" placeholder="专用发票请填写注册电话" />
        </div>
        <div class="form-row">
          <span class="form-label">收票邮箱</span>
          <Input v-model="form.send_mail" placeholder="输入电子邮箱，后续开票成功发票文件将默认推送至该邮箱" />
        </div>
      </template>

      <!-- 发票类型 -->
      <div class="form-row">
        <span class="form-label required">发票类型</span>
        <RadioGroup v-model="form.tax_type">
          <Radio :label="0">增值税普通发票</Radio>
          <Radio :label="1" :disabled="form.type === 0">增值税专用发票</Radio>
        </RadioGroup>
        <span v-if="form.type === 0" class="form-tip">（个人仅可开具增值税普通发票）</span>
      </div>
    </div>

    <div class="modal-footer">
      <div class="btn cancel" @click="onCancel">取消</div>
      <div class="btn confirm" @click="onConfirm">保存设置</div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'InvoiceTitleModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    titleData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        type: 0,
        title: '',
        tax_number: '',
        company_address: '',
        phone: '',
        bank_name: '',
        bank_account: '',
        send_mail: '',
        tax_type: 0,
      },
    }
  },
  watch: {
    visible(val) {
      if (val && this.titleData) {
        console.log('this.titleData', this.titleData)
        // user_tax_info.type 抬头类型: 0-个人, 1-企业（与后端一致，直接映射）
        const type = Number(this.titleData.type) || 0;
        this.form = {
          type: type,
          title: this.titleData.title || '',
          tax_number: this.titleData.tax_number || '',
          company_address: this.titleData.company_address || '',
          phone: this.titleData.phone || '',
          bank_name: this.titleData.bank_name || '',
          bank_account: this.titleData.bank_account || '',
          send_mail: this.titleData.send_mail || '',
          // 个人仅可开具普票
          tax_type: this.titleData.tax_type || 0,
        }
      }
    },
    'form.type'(val) {
      // 切换为个人抬头时，强制回退为普票
      if (val === 0) {
        this.form.tax_type = 0
      }
    },
  },
  methods: {
    onVisibleChange(val) {
      this.$emit('update:visible', val)
    },
    onCancel() {
      this.$emit('cancel')
      this.$emit('update:visible', false)
    },
    onConfirm() {
      if (!this.form.title) {
        this.$Message.warning('请输入发票抬头')
        return
      }
      // 企业抬头必须填税号（type=1 企业）
      if (this.form.type === 1) {
        if (!this.form.tax_number) {
          this.$Message.warning('请输入税号')
          return
        }
      }
      // 个人仅可开具普票（type=0 个人）
      if (this.form.type === 0 && this.form.tax_type !== 0) {
        this.$Message.warning('个人仅可开具增值税普通发票')
        return
      }
      // 专票必填项（仅企业 type=1 且专票 tax_type=1）
      if (this.form.type === 1 && this.form.tax_type === 1) {
        const requiredList = [
          ['bank_name', '请输入开户银行'],
          ['bank_account', '请输入银行账号'],
          ['company_address', '请输入企业地址'],
          ['phone', '请输入企业电话'],
        ]
        for (let i = 0; i < requiredList.length; i++) {
          if (!this.form[requiredList[i][0]]) {
            this.$Message.warning(requiredList[i][1])
            return
          }
        }
      }
      this.$emit('confirm', { ...this.form })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .invoice-title-modal {
  text-align: left;
  .ivu-modal-content {
    border-radius: 8px;
  }

  .ivu-modal-body {
    padding: 0;
  }

  .ivu-modal-close {
    top: 16px;
    right: 16px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;

  .modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #1a1a1a;
  }
}

.modal-body {
  padding: 24px;

  .form-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    .form-label {
      display: block;
      font-size: 14px;
      color: #333333;
      width: 80px;
      text-align: left;

      &.required::after {
        content: '*';
        color: #ff5967;
        margin-left: 4px;
      }
    }

    ::v-deep .ivu-radio-wrapper {
      margin-right: 20px;
    }

    .form-tip {
      font-size: 12px;
      color: #999999;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 24px;
  border-top: 1px solid #f0f0f0;

  .btn {
    min-width: 120px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 20px;

    &.cancel {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      color: #999999;
    }

    &.confirm {
      background: #ff5967;
      color: #ffffff;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
  /* 覆盖选中时的背景色和边框色 */
  /* 1. 覆盖选中状态的外层边框和背景 */
  ::v-deep   .ivu-radio-checked .ivu-radio-inner {
    border-color: #FF5967 !important;
  }

  /* 2. ⚠️ 核心：覆盖内部圆点的颜色（伪元素 ::after） */
  ::v-deep   .ivu-radio-checked .ivu-radio-inner::after {
    background-color: #FF5967 !important; /* 将圆点改为你想要的颜色 */
  }
</style>
